// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2atKn","selects":"Documents_selects__2KtKq"};